import React, { useState, useEffect } from "react";
import axios, { formToJSON } from "axios";
import { useParams } from "react-router-dom";
import { Link } from "react-router-dom";
import { CiLock } from "react-icons/ci";
import HoaNavbar from "../HoaNavbar/HoaNavbar";
import HoaFooter from "../HoaFooter/HoaFooter";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSync } from "@fortawesome/free-solid-svg-icons";
import { API_URL } from "../../apiConfig";
import LoadingComman from "../Loading/LoadingCommon";
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';

const HoaRegisterForm = () => {
    const [selectedCountryId, setSelectedCountryId] = useState(0);
    const [loadingComman, setLoadingComman] = useState(false);
    const { roleId, boardMemberRole } = useParams();
    const [acceptTerms, setAcceptTerms] = useState(false);
    const RoleId = parseInt(roleId);
    console.log(roleId);
    const currentDate = new Date().toISOString().slice(0, 10);
    console.log(currentDate);  // Output: YYYY-MM-DD
    const handleKeyPress = (e) => {
        if (!/[0-9]/.test(e.key)) {
            e.preventDefault();
        }
    };
    const [formData, setFormData] = useState({
        addressDto: {
            activeStatus: true,
            address: "",
            addressId: 0,
            city: "",
            countryId: 0,
            stateId: 0,
            zipCode: 0,
        },
        boardMemberRole: boardMemberRole || "",
        clientDto: {
            activeStatus: true,
            clientid: 0,
            communityid: 0,
            displayname: "",
            numberofhouses: 0,
            userid: 0,
        },
        contractCode: "",
        communityCode: null,
        userDto: {
            activeStatus: false,
            emailId: "",
            emailIdIsVerified: true,
            firstName: "",
            isClient: true,
            lastLogin: "",
            lastName: "",
            middleName: "",
            createdDate: new Date().toISOString(),
            modifiedById: 0,
            modifiedDate: new Date().toISOString(),
            mobileIsVerified: true,
            mobileNumber: "",
            otp: 0,
            password: "",
            roleId: RoleId,
            userId: 0,
            userProfileUrl: ""
        },
    });

    const [errors, setErrors] = useState({});
    const [verified, setVerified] = useState(false);
    const [captchaValid, setCaptchaValid] = useState(false);
    const [userInput, setUserInput] = useState("");
    const [generatedCaptcha, setGeneratedCaptcha] = useState(generateCaptcha());
    const [captchaErrorMessage, setCaptchaErrorMessage] = useState(null);
    const [countryData, setCountryData] = useState([]);
    const [stateData, setStateData] = useState([]);
    console.log(countryData);
    useEffect(() => {
        axios
            .get(`${API_URL}/public/country/getAll`)
            .then((response) => {
                setCountryData(response.data);
                console.log(response.data);
            })
            .catch((error) => {
                console.error("Error fetching countries:", error);
            });
        axios
            .get(`${API_URL}/public/state/getAll`)
            .then((response) => {
                setStateData(response.data);
            })
            .catch((error) => {
                console.error("Error fetching states:", error);
            });
    }, []);

    useEffect(() => {
        setFormData((prevState) => ({
            ...prevState,
            clientDto: {
                ...prevState.clientDto,
                displayname: prevState.userDto.firstName,
            },
        }));
    }, [formData.userDto.firstName]);

    function generateCaptcha() {
        const characters =
            "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        let captcha = "";
        for (let i = 0; i < 6; i++) {
            // Change 6 to the desired length of the captcha
            const randomIndex = Math.floor(Math.random() * characters.length);
            captcha += characters[randomIndex];
        }
        return captcha;
    }

    function handleInputChange(event) {
        setUserInput(event.target.value);
    }

    function regenerateCaptcha() {
        setGeneratedCaptcha(generateCaptcha());
    }

    const [contractCode, setContractCode] = useState('');
    const [contractData, setContractData] = useState(null);
    const handleContractCodeChange = (e) => {
        const newContractCode = e.target.value;
        setContractCode(newContractCode);

        // Update formData with the new contract code
        setFormData((prevFormData) => ({
            ...prevFormData,
            contractCode: newContractCode,
        }));
    };

    useEffect(() => {
        if (contractCode) {
            fetchContractData(contractCode);
        }
    }, [contractCode]);
    useEffect(() => {
        if (contractData) {
            if (contractData.addressId) {
                fetchAddressData(contractData.addressId);
            }
        }
    }, [contractData]);
    const fetchContractData = async (code) => {
        try {
            const response = await fetch(`${API_URL}/public/clientRequest/contractCode/${code}`);
            if (response.ok) {
                const data = await response.json();
                setContractData(data);
            } else {
                console.error('Failed to fetch contract data');
            }
        } catch (error) {
            console.error('Error fetching contract data:', error);
        }
    };
    const fetchAddressData = async (addressId) => {
        try {
            const response = await fetch(`${API_URL}/public/address/getOne/${addressId}`);
            if (response.ok) {
                const data = await response.json();
                const addressFormDataUpdate = {
                    addressDto: {
                        activeStatus: true,
                        address: '',
                        addressId: 0,
                        city: data.city,
                        countryId: data.countryId,
                        stateId: data.stateId,
                        zipCode: data.zipCode,
                    }
                };
                setSelectedCountryId(data.countryId);
                console.log(data.countryId);
                setFormData((prevFormData) => ({
                    ...prevFormData,
                    addressDto: addressFormDataUpdate.addressDto,
                }));
                // setAddressData(data);
            } else {
                console.error('Failed to fetch address data');
            }
        } catch (error) {
            console.error('Error fetching address data:', error);
        }
    };

    const validateForm = async () => {
        let isValid = true; // Track the overall validity
        const newErrors = {}; // Store error messages

        // Validate each field
        if (!formData.userDto.firstName || !formData.userDto.firstName.trim()) {
            newErrors.firstName = "Please provide your first name.";
            isValid = false;
        }
        if (!formData.userDto.lastName || !formData.userDto.lastName.trim()) {
            newErrors.lastName = "Please provide your last name.";
            isValid = false;
        }
        if (!formData.addressDto.address || !formData.addressDto.address.trim()) {
            newErrors.address = "Please provide your address.";
            isValid = false;
        }
        if (!formData.addressDto.countryId) {
            newErrors.countryId = "Please select your country name.";
            isValid = false;
        }
        if (!formData.addressDto.stateId) {
            newErrors.stateId = "Please select your state name.";
            isValid = false;
        }

        if (!formData.userDto.emailId || !formData.userDto.emailId.trim()) {
            newErrors.emailId = "Please provide your email address.";
            isValid = false;
        } else if (!/^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/.test(formData.userDto.emailId)) {
            newErrors.emailId = "Please provide a valid email address (lowercase letters only).";
            isValid = false;
        } else if (!formData.userDto.emailId.endsWith('@gmail.com')) {
            newErrors.emailId = "Email must be a Gmail address.";
            isValid = false;
        } else {
            const email = formData.userDto.emailId;
            const isEmailAvailable = await handleEmailCheck(email);
            if (!isEmailAvailable) {
            } else {
                newErrors.emailId = 'Email is already taken';
                isValid = false;
            }
        }

        if (!formData.userDto.mobileNumber ||
            formData.userDto.mobileNumber.length < 10 ||
            !/^\d+$/.test(formData.userDto.mobileNumber)) {
            newErrors.mobileNumber = "Please enter a valid phone number.";
            isValid = false;
        }

        if (!formData.addressDto.city || !formData.addressDto.city.trim()) {
            newErrors.city = "Please provide your city.";
            isValid = false;
        }

        if (!formData.addressDto.zipCode || !String(formData.addressDto.zipCode).trim()) {
            newErrors.zipCode = "Please provide your zip code.";
            isValid = false;
        }

        if (!formData.contractCode || !formData.contractCode.trim()) {
            newErrors.contractCode = "Please provide your Contract Code.";
            isValid = false;
        }

        // Captcha validation
        if (!userInput) {
            newErrors.captcha = "Please fill in the captcha.";
            isValid = false;
        } else if (userInput !== generatedCaptcha) {
            newErrors.captcha = "Captcha is incorrect.";
            isValid = false;
        }

        // Terms and conditions validation
        if (!acceptTerms) {
            newErrors.acceptTerms = "You must accept the terms and conditions.";
            isValid = false;
        }

        setErrors(newErrors); // Set the error messages in state
        console.log(newErrors); // Log errors for debugging

        // Return true if there are no errors (all validations passed), false otherwise
        return isValid;
    };



    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevState) => {
            const updatedFormData = { ...prevState };
            const fieldPath = name.split('.');
            if (name === "addressDto.countryId") {
                const countryId = parseInt(value, 10);
                setSelectedCountryId(countryId);
                updatedFormData.addressDto.countryId = countryId;
            } else if (name === "addressDto.stateId") {
                updatedFormData.addressDto.stateId = parseInt(value, 10);
            } else if (name === "userDto.roleId") {
                updatedFormData.userDto.roleId = parseInt(value, 10);
            } else if (name === "userDto.mobileNumber") {
                updatedFormData.userDto.mobileNumber = value.replace(/\D/g, "").slice(0, 10);
            } else if (fieldPath.length === 2) {
                updatedFormData[fieldPath[0]][fieldPath[1]] = value;
            } else if (fieldPath.length === 3) {
                updatedFormData[fieldPath[0]][fieldPath[1]] = (fieldPath[1] === 'countryId' || fieldPath[1] === 'stateId') ? parseInt(value, 10) : value;
            } else {
                updatedFormData[name] = value;
            }

            return updatedFormData;
        });
    };


    const handleEmailCheck = async (email) => {
        console.log("Checking email availability...");
        try {
            const response = await axios.get(`${API_URL}/user/check/email?emailId=${email} `);
            if (response.status === 200) {
                return false;
            }
            return true;
        } catch (error) {
            console.error('Error checking email:', error);
            return true;
        }
    };


    const handleSubmit = async (e) => {
        e.preventDefault();
        console.log("before validation", formData);
        const isValid = await validateForm();
        if (isValid) {
            setLoadingComman(true);
            console.log("after validation :", formData);
            try {
                const response = await axios.post(`${API_URL}/public/clientRequest/add`, formData);
                console.log("Form submitted successfully:", response.data);
                alert("Registered Successfully");
                window.location.href = "/";
            } catch (error) {
                console.error("Error submitting form:", error);
            } finally {
                setLoadingComman(false);
            }
        } else {
            setLoadingComman(false);
        }
    };

    const handleCancel = () => {
        setFormData({
            addressDto: {
                activeStatus: true,
                address: "",
                addressId: 0,
                city: "",
                countryId: 0,
                stateId: 0,
                zipCode: 0,
            },
            boardMemberRole: "",
            clientDto: {
                activeStatus: true,
                clientid: 0,
                communityid: 0,
                displayname: "",
                numberofhouses: 0,
                userid: 0,
            },
            contractCode: "",
            communityCode: null,
            userDto: {
                activeStatus: false,
                emailId: "",
                emailIdIsVerified: true,
                firstName: "",
                isClient: true,
                lastLogin: "",
                lastName: "",
                middleName: "",
                createdDate: "",
                modifiedById: 0,
                modifiedDate: "",
                mobileIsVerified: true,
                mobileNumber: "",
                otp: 0,
                password: "",
                roleId: RoleId,
                userId: 0,
            }
        });
        setErrors({});
        setUserInput("");
        setCaptchaValid(false);
        setCaptchaErrorMessage(null);
        regenerateCaptcha();
        setAcceptTerms(false);
    };

    const displayValue = (value) => {
        return value === 0 ? "" : value;
    };



    return (
        <>
            <div className="fixed top-0">
                <HoaNavbar />
            </div>
            {loadingComman && <LoadingComman />}
            {!loadingComman && (
                <div className="mt-[70px]">
                    <div className="bg-blue-800 text-white w-[85%] mx-auto my-5 py-5 shadow-[0px_4px_4px_0px_rgba(0,0,0,0.3)]">
                        <div className="w-[85%] mx-auto my-5 flex flex-col gap-5">
                            <h2 className="text-white">Client Form</h2>
                            <p className="text-base flex gap-2.5 items-center text-white">Please enter your info below. * is mandatory</p>
                        </div>
                        <form onSubmit={handleSubmit}>
                            <div className="w-[85%] mx-auto flex flex-wrap items-start gap-5 py-2.5">
                                <div className="w-full">
                                    <label htmlFor="contractCode" className="block mb-1 text-white">Contract Code*</label>
                                    <input
                                        type="text"
                                        className="w-full rounded-lg block border-none outline-none p-2.5 text-black text-base transition-all duration-150 ease-in-out bg-white focus:text-gray-600 focus:bg-white focus:border-blue-800 focus:outline-none focus:shadow-[0_0.125rem_0.25rem_rgba(165,163,174,.3)]"
                                        name="contractCode"
                                        id="contractCode"
                                        value={contractCode}
                                        onChange={handleContractCodeChange}
                                    />
                                    {errors.contractCode && (
                                        <span className="text-white">{errors.contractCode}</span>
                                    )}
                                </div>
                                <div className="w-full sm:w-[calc(50%-20px)] lg:w-[calc(33.33%-20px)]">
                                    <label htmlFor="firstName" className="block mb-1 text-white">First Name *</label>
                                    <input
                                        type="text"
                                        name="userDto.firstName"
                                        id="firstName"
                                        placeholder="Please Enter"
                                        value={formData.userDto.firstName}
                                        onChange={handleChange}
                                        className="w-full rounded-lg block border-none outline-none p-2.5 text-black text-base transition-all duration-150 ease-in-out bg-white focus:text-gray-600 focus:bg-white focus:border-blue-800 focus:outline-none focus:shadow-[0_0.125rem_0.25rem_rgba(165,163,174,.3)]"
                                        maxLength={50}
                                    />

                                    {errors.firstName && (
                                        <span className="text-white">{errors.firstName}</span>
                                    )}
                                </div>
                                <div className="w-full sm:w-[calc(50%-20px)] lg:w-[calc(33.33%-20px)]">
                                    <label htmlFor="middleName" className="block mb-1 text-white">Middle Name</label>
                                    <input
                                        type="text"
                                        name="userDto.middleName"
                                        id="middleName"
                                        placeholder="Optional"
                                        value={formData.userDto.middleName}
                                        onChange={handleChange}
                                        className="w-full rounded-lg block border-none outline-none p-2.5 text-black text-base transition-all duration-150 ease-in-out bg-white focus:text-gray-600 focus:bg-white focus:border-blue-800 focus:outline-none focus:shadow-[0_0.125rem_0.25rem_rgba(165,163,174,.3)]"
                                        maxLength={50}
                                    />
                                </div>
                                <div className="w-full sm:w-[calc(50%-20px)] lg:w-[calc(33.33%-20px)]">
                                    <label htmlFor="lastName" className="block mb-1 text-white">Last Name *</label>
                                    <input
                                        type="text"
                                        name="userDto.lastName"
                                        id="lastName"
                                        placeholder="Please Enter"
                                        value={formData.userDto.lastName}
                                        onChange={handleChange}
                                        className="w-full rounded-lg block border-none outline-none p-2.5 text-black text-base transition-all duration-150 ease-in-out bg-white focus:text-gray-600 focus:bg-white focus:border-blue-800 focus:outline-none focus:shadow-[0_0.125rem_0.25rem_rgba(165,163,174,.3)]"
                                        maxLength={50}
                                    />
                                    {errors.lastName && (
                                        <span className="text-white">{errors.lastName}</span>
                                    )}
                                </div>

                                <div className="w-full sm:w-[calc(50%-20px)]">
                                    <label htmlFor="mobileNumber" className="block mb-1 text-white">Phone number *</label>
                                    <div className="phone-input-wrapper">
                                        <PhoneInput
                                            country={'us'}
                                            value={formData.userDto.mobileNumber}
                                            onChange={(value) => setFormData({ ...formData, userDto: { ...formData.userDto, mobileNumber: value } })}
                                            inputStyle={{
                                                width: '100%',
                                                borderRadius: '8px',
                                                display: 'block',
                                                border: 'none',
                                                outline: 'none',
                                                color: '#000000',
                                                fontSize: '1rem',
                                                transition: 'all 0.15s ease-in-out',
                                                height: '40px',
                                                backgroundColor: '#FFFFFF'
                                            }}
                                        />
                                    </div>
                                    {errors.mobileNumber && (
                                        <span className="text-white">{errors.mobileNumber}</span>
                                    )}
                                </div>

                                <div className="w-full sm:w-[calc(50%-20px)]">
                                    <label htmlFor="emailId" className="block mb-1 text-white">Email Address *</label>
                                    <input
                                        type="email"
                                        name="userDto.emailId"
                                        id="emailId"
                                        placeholder="Email Address"
                                        value={formData.userDto.emailId}
                                        onChange={handleChange}
                                        className="w-full rounded-lg block border-none outline-none p-2.5 text-black text-base transition-all duration-150 ease-in-out bg-white focus:text-gray-600 focus:bg-white focus:border-blue-800 focus:outline-none focus:shadow-[0_0.125rem_0.25rem_rgba(165,163,174,.3)]"
                                        maxLength={100}
                                    />
                                    {errors.emailId && (
                                        <span className="text-white">{errors.emailId}</span>
                                    )}

                                </div>
                                <div className="w-full sm:w-[calc(50%-20px)]">
                                    <label htmlFor="address" className="block mb-1 text-white">Address *</label>
                                    <input
                                        type="text"
                                        name="addressDto.address"
                                        id="address"
                                        placeholder="Address"
                                        value={formData.addressDto.address}
                                        onChange={handleChange}
                                        className="w-full rounded-lg block border-none outline-none p-2.5 text-black text-base transition-all duration-150 ease-in-out bg-white focus:text-gray-600 focus:bg-white focus:border-blue-800 focus:outline-none focus:shadow-[0_0.125rem_0.25rem_rgba(165,163,174,.3)]"
                                        maxLength={100}
                                    />
                                    {errors.address && (
                                        <span className="text-white">{errors.address}</span>
                                    )}
                                </div>

                                <div className="w-full sm:w-[calc(50%-20px)]">
                                    <label htmlFor="countryId" className="block mb-1 text-white">Country *</label>
                                    <select
                                        id="countryId"
                                        name="addressDto.countryId"
                                        value={formData.addressDto.countryId}
                                        onChange={(e) => e.preventDefault()}
                                        className="w-full rounded-lg block border-none outline-none p-2.5 text-black text-base transition-all duration-150 ease-in-out bg-white focus:text-gray-600 focus:bg-white focus:border-blue-800 focus:outline-none focus:shadow-[0_0.125rem_0.25rem_rgba(165,163,174,.3)]"
                                    >
                                        <option value="">Filter country</option>
                                        {countryData?.map((country) => (
                                            <option key={country.countryid} value={country.countryid}>
                                                {country.countryname}
                                            </option>
                                        ))}
                                    </select>
                                    {errors.countryId && (
                                        <span className="text-white">{errors.countryId}</span>
                                    )}
                                </div>
                                <div className="w-full sm:w-[calc(50%-20px)]">
                                    <label htmlFor="stateId" className="block mb-1 text-white">State *</label>
                                    <select
                                        id="stateId"
                                        name="addressDto.stateId"
                                        value={formData.addressDto.stateId}
                                        onChange={(e) => e.preventDefault()}
                                        className="w-full rounded-lg block border-none outline-none p-2.5 text-black text-base transition-all duration-150 ease-in-out bg-white focus:text-gray-600 focus:bg-white focus:border-blue-800 focus:outline-none focus:shadow-[0_0.125rem_0.25rem_rgba(165,163,174,.3)]"
                                    >
                                        <option value="">Filter State</option>
                                        {stateData
                                            .filter((state) => state.countryid === selectedCountryId)
                                            .map((state) => (
                                                <option key={state.stateid} value={state.stateid}>
                                                    {state.statename}
                                                </option>
                                            ))}
                                    </select>
                                    {errors.stateId && (
                                        <span className="text-white">{errors.stateId}</span>
                                    )}
                                </div>

                                <div className="w-full sm:w-[calc(50%-20px)]">
                                    <label htmlFor="city" className="block mb-1 text-white">City *</label>
                                    <input
                                        type="text"
                                        name="city"
                                        id="city"
                                        value={formData.addressDto.city}
                                        onChange={handleChange}
                                        placeholder="City"
                                        className="w-full rounded-lg block border-none outline-none p-2.5 text-black text-base transition-all duration-150 ease-in-out bg-white focus:text-gray-600 focus:bg-white focus:border-blue-800 focus:outline-none focus:shadow-[0_0.125rem_0.25rem_rgba(165,163,174,.3)]"
                                        maxLength={50}
                                        readOnly
                                    />
                                    {errors.city && (
                                        <span className="text-white">{errors.city}</span>
                                    )}
                                </div>
                                <div className="w-full sm:w-[calc(50%-20px)]">
                                    <label htmlFor="zipCode" className="block mb-1 text-white">Zip Code *</label>
                                    <input
                                        type="text"
                                        name="addressDto.zipCode"
                                        id="zipCode"
                                        value={displayValue(formData.addressDto.zipCode)}
                                        onChange={handleChange}
                                        placeholder="Zip Code"
                                        onKeyPress={handleKeyPress}
                                        maxLength={10}
                                        className="w-full rounded-lg block border-none outline-none p-2.5 text-black text-base transition-all duration-150 ease-in-out bg-white focus:text-gray-600 focus:bg-white focus:border-blue-800 focus:outline-none focus:shadow-[0_0.125rem_0.25rem_rgba(165,163,174,.3)]"
                                        readOnly
                                    />
                                    {errors.zipCode && (
                                        <span className="text-white">{errors.zipCode}</span>
                                    )}
                                </div>
                            </div>

                            <div className="w-[85%] mx-auto flex flex-wrap items-start gap-5 py-2.5">
                                <div className="w-full mb-2.5">
                                    <div className="custom-checkbox-container">
                                        <input
                                            type="checkbox"
                                            id="acceptTerms"
                                            checked={acceptTerms}
                                            onChange={() => setAcceptTerms(!acceptTerms)}
                                            className="hidden"
                                        />
                                        <label
                                            htmlFor="acceptTerms"
                                            className="relative pl-7 cursor-pointer text-white before:absolute before:left-0 before:top-0 before:w-5 before:h-5 before:border before:border-gray-300 before:rounded before:bg-white after:content-['✓'] after:font-bold after:text-base after:absolute after:top-0.5 after:left-0.5 after:hidden after:text-blue-800"
                                            style={{
                                                ':after': acceptTerms ? { display: 'block' } : { display: 'none' }
                                            }}
                                        >
                                            <Link to="" className="text-white no-underline">
                                                Terms of Use, Privacy Policy, Terms & Conditions
                                            </Link>
                                        </label>
                                    </div>
                                    {errors.acceptTerms && <span className="text-white">{errors.acceptTerms}</span>}
                                </div>
                                <div className="w-full">
                                    <div className="flex items-center flex-col sm:flex-row sm:justify-between">
                                        <div className="flex items-center gap-2.5 flex-col sm:flex-row">
                                            <div className="flex-1 rounded-md p-2.5 flex justify-center items-center">
                                                <div className="w-[150px] text-xl font-bold text-gray-800 rounded-md">
                                                    <p className="w-full tracking-wide flex justify-center items-center text-xl font-semibold text-gray-800 m-0">
                                                        {generatedCaptcha}
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="max-w-[50px] text-center cursor-pointer text-lg text-white bg-blue-800 p-2.5 rounded-md shadow-[rgba(50,50,93,0.25)_0px_50px_100px_-20px,rgba(0,0,0,0.3)_0px_30px_60px_-30px]">
                                                <FontAwesomeIcon
                                                    icon={faSync}
                                                    onClick={regenerateCaptcha}
                                                />
                                            </div>
                                            <div className="w-full flex-1 border-none rounded-md text-lg">
                                                <input
                                                    maxLength={6}
                                                    type="text"
                                                    value={userInput}
                                                    onChange={handleInputChange}
                                                    placeholder="Enter Captcha"
                                                    className="w-full border-none p-2.5 outline-none text-base bg-white text-black"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    {errors.captcha && <span className="text-white">{errors.captcha}</span>}
                                </div>
                            </div>

                            <div className="px-2.5 flex justify-end items-center gap-2.5 flex-col sm:flex-row">
                                <button
                                    className="text-center bg-blue-800 text-white text-lg font-bold cursor-pointer border-none rounded-[0.3125rem] py-4 px-16 hover:cursor-pointer hover:border hover:border-white"
                                    type="button"
                                    onClick={handleCancel}
                                >
                                    Cancel
                                </button>
                                <button className="text-center bg-white text-blue-800 text-lg font-bold cursor-pointer border-none rounded-[0.3125rem] py-4 px-16">
                                    Confirm
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
            <div>
                <HoaFooter />
            </div>
        </>
    );
};

export default HoaRegisterForm;